export default "__VITE_ASSET__9dffe687__"